import { onMounted } from 'vue';
import { getToken, decode } from '@/utils/Token';
import { useEspecialidade } from './useEspecialidade';
import { CoresHelper } from '@/utils/coresHelper';
import http from '@/services/ApiConfig';

export function useAuthEspecialidade() {
  const { definirEspecialidade } = useEspecialidade();

  const aplicarEspecialidadeDoUsuario = async () => {
    const token = getToken();
    if (!token) return;

    const user = decode(token);

    try {
      const response = await http.get(`usuarios/${user.id}`, { headers: { Authorization: `Bearer ${token}` } });
      const usuario = response.data;

      if (usuario?.ignorarCorEspecialidade === true) {
        CoresHelper.limparEspecialidade();
        definirEspecialidade('PADRAO');
        return;
      }

      if (user.especialidade && user.especialidade.trim() !== '') {
        definirEspecialidade(user.especialidade);
      } else {
        definirEspecialidade('PADRAO');
      }
    } catch (e) {
      CoresHelper.limparEspecialidade();
      definirEspecialidade('PADRAO');
    }
  };

  onMounted(() => {
    aplicarEspecialidadeDoUsuario();
  });

  return {
    aplicarEspecialidadeDoUsuario,
  };
}
